import {AxiosError} from 'axios';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig, HTTP_REQUEST_HEADER} from 'libs/api/api';

/**
 * Sends a request to visibly api and returns whether its successful or not
 */
export const validateVisiblyFields = ({
    dateOfBirth,
    examID,
    onFailure,
    onSuccess,
    state,
}: {
    examID: number;
    state: string;
    dateOfBirth: string;
    onSuccess: (data: {expiresAt: string; status: number; url: string}) => void;
    onFailure: (data: AxiosError) => void;
}) =>
    apiConfig.instanceGusaBackend
        .get(
            `${ENDPOINTS.GET_EXAM_LINK({id: examID.toString()})}?regionCode=${state}&birthdate=${dateOfBirth}&filling=now`,
            {
                baseURL: apiConfig.API_URL,
                headers: {
                    [HTTP_REQUEST_HEADER.AUTHORIZATION]: '',
                },
            },
        )
        .then(({data}) => onSuccess(data))
        .catch(onFailure);
